var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFix = function SvgFix(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m3.999 4 3 3m-3-3h-2l-.667-2 .667-.667 2 .667zm8.839-2.173L11.086 3.58c-.264.264-.396.396-.445.548a.67.67 0 0 0 0 .412c.05.152.181.284.445.549l.159.158c.264.264.396.396.548.445a.67.67 0 0 0 .412 0c.152-.05.284-.181.548-.445l1.639-1.639a3.667 3.667 0 0 1-4.106 4.99c-.325-.064-.487-.096-.585-.086a.56.56 0 0 0-.249.076c-.087.046-.174.134-.349.308l-4.771 4.772a1.414 1.414 0 1 1-2-2l4.771-4.772c.175-.174.262-.262.309-.349a.56.56 0 0 0 .075-.248c.01-.098-.022-.26-.086-.585Q7.333 5.367 7.332 5a3.667 3.667 0 0 1 5.506-3.173M7.998 10l3.667 3.666a1.414 1.414 0 1 0 2-2L10.65 8.65a3.7 3.7 0 0 1-.623-.114c-.26-.071-.544-.02-.734.17z",
    opacity: 0.7
  })));
};
export default SvgFix;